import { t, jt } from 'ttag'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { Flex } from '@h2/components/layout/flex'
import { Box as BoxComponent } from '@h2/components/layout/box'
import { PromoButton } from '@h2/components/buttons/promo'
import { Text } from '@h2/components/typography/text'
import { SY10S } from '@h2/components/colors'
import { openSigninDialog } from '@main/actions/signinOrRegisterDialog'

const Box = styled(BoxComponent)`
  button {
    border-color: transparent;

    &:hover {
      background-color: ${SY10S};
    }

    &:nth-of-type(1) {
      margin-right: 10px;
    }

    &:nth-of-type(2) {
      margin: 0 10px;
    }
  }
`
const CallToAction = () => {
  const dispatch = useDispatch()
  const { pathname } = useLocation()
  const saveYourProgress = <strong key="save">{t`save your progress`}</strong>
  const advancedFeatures = <strong key="advanced">{t`advanced features`}</strong>

  if (/signin|register|combine/.test(pathname)) {
    return null
  }

  return (
    <Flex>
      <Box>
        <Text color="white">
          <PromoButton onClick={() => dispatch(openSigninDialog('signIn'))}>
            {t`Sign in`}
          </PromoButton>
          <span>{t`or`}</span>
          <PromoButton onClick={() => dispatch(openSigninDialog('createAccount'))}>
            {t`Create a free account`}
          </PromoButton>
          <span>{jt`to ${saveYourProgress} and access more ${advancedFeatures}`}</span>
        </Text>
      </Box>
    </Flex>
  )
}

export { CallToAction }
